import { styled } from '@mui/system';
import { Box, Card, Typography, Chip } from '@mui/material';
import { colors, fontFamilies } from '../../../../../constants/theme';
import { SectionHeading as BaseSectionHeading } from '../../../../../ui/typography';
export const SectionWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
}));

export const ContentContainer = styled(Box)(({ theme }) => ({
  maxWidth: 1200,
  width: '100%',
  margin: '0 auto',
  [theme.breakpoints.down('md')]: {
    padding: '0 20px',
  },
  [theme.breakpoints.down('sm')]: {
    padding: '0 16px',
  },
}));

export const SectionHeading = styled(BaseSectionHeading)(({ theme }) => ({
  ...theme.typography.heading,
  textAlign: 'center',
  marginBottom: 32,
}));

export const CredentialsGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: 24,
  alignItems: 'stretch',
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: '1fr',
  },
}));

export const CredentialCard = styled(Card)(({ theme }) => ({
  backgroundColor: colors.whiteText,
  borderRadius: 16,
  padding: 32,
  boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
  minHeight: 'min-content',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.down('md')]: {
    padding: 24,
    borderRadius: 12,
  },
  [theme.breakpoints.down('sm')]: {
    padding: 16,
  },
}));

export const LanguagesCard = styled(CredentialCard)(({ theme }) => ({
  minHeight: 140,
  gridColumn: '1 / -1',
  [theme.breakpoints.down('md')]: {
    gridColumn: '1',
  },
}));

export const CardTitle = styled(Typography)(({ theme }) => ({
  fontFamily: fontFamilies.gotham,
  fontSize: 20,
  fontWeight: 600,
  color: colors.primary,
  marginBottom: 16,
  [theme.breakpoints.down('md')]: {
    fontSize: 18,
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: 16,
  },
}));

export const ListContainer = styled(Box)({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: 12,
  overflow: 'hidden',
  height: 'min-content',
});

export const ListItem = styled(Box)({
  display: 'flex',
  alignItems: 'flex-start',
  gap: 16,
  padding: '4px 0',
});

export const ListBullet = styled(Box)({
  width: 6,
  height: 6,
  backgroundColor: colors.secondary,
  borderRadius: '50%',
  marginTop: 8,
  flexShrink: 0,
});

export const ListText = styled(Typography)({
  fontFamily: fontFamilies.quicksand,
  fontSize: 15,
  fontWeight: 400,
  color: '#2c2c2c',
  lineHeight: 1.4,
  flex: 1,
});

export const LanguagesContainer = styled(Box)({
  display: 'flex',
  flexWrap: 'wrap',
  gap: 16,
  alignItems: 'center',
  flex: 1,
});

export const LanguageChip = styled(Chip)({
  backgroundColor: colors.secondary,
  color: colors.whiteText,
  fontFamily: fontFamilies.quicksand,
  fontSize: 14,
  fontWeight: 600,
  padding: '6px 16px',
  height: 36,
  borderRadius: 18,
  '& .MuiChip-label': {
    padding: '0 8px',
  },
});

export const NoDataText = styled(Typography)({
  textAlign: 'center',
  color: colors.textLight,
  fontFamily: fontFamilies.quicksand,
  fontSize: 16,
  marginTop: 32,
});
